import React from "react";

export function Logo() {
  return <img src="/Logo.svg" alt="로고" />;
}
